import handleError from "../../errorHandler";
import Axios from "axios";
import { getCookieValue } from "../../cookieHelper";
import { GET_TWT_TOKEN, GET_TWT_TOKEN_SUCCESS, GET_TWT_TOKEN_FAILURE, TRIGGER_TOAST } from "../constants";

const getTWTToken = () => {
  return async (dispatch: any) => {
    dispatch({ type: GET_TWT_TOKEN });
    let dynamicIdToken = getCookieValue(`${process.env.REACT_APP_ENV}IdToken`);
    const request = {
      headers: {
        "content-type": "application/json",
        "x-dynamic-token": dynamicIdToken
      }
    }
    await Axios.get(`https://${process.env.REACT_APP_ENVIRONMENT}teacherapi.globalenglish.com/twt/dynamic-id-token`, request).then((response) => {
      dispatch({ type: GET_TWT_TOKEN_SUCCESS, payload: response.data });
    }).catch((err: any) => {
      console.log(err);
      dispatch({ type: GET_TWT_TOKEN_FAILURE });
      dispatch({
        type: TRIGGER_TOAST,
        payload: {
          shouldShow: true,
          severity : 'error',
          transMessage: "message_errorDefault"
        },
      });
    });
  }
};
  
export default { getTWTToken }
  